// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

/* URL UPDATE WITH TURBO VISITS */
// import NavigationController from "./navigation_controller"
// application.register("navigation", NavigationController)

import FormController from "./form_controller.js"
application.register("form", FormController)

import SwalController from "./swal_controller.js"
application.register("swal", SwalController)

import TableFiltersController from "./table_filters_controller.js"
application.register("table-filters", TableFiltersController)

import TableExportController from "./table_export_controller.js"
application.register("table-export", TableExportController)

import DropzoneController from "./dropzone_controller.js"
application.register("dropzone", DropzoneController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TownsController from "./towns_controller"
application.register("towns", TownsController)

import ChildrenController from "./children_controller"
application.register("children", ChildrenController)

import WebNotificationController from "./web_notification_controller"
application.register("web-notification", WebNotificationController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import 'swiper/css/bundle'